import { Col, Row, Switch } from 'antd';
import {
  deleteNonSelfTrainingStageAPI,
  getNonSelfTrainingStageAPI,
  mutateNonSelfTrainingStageAPI,
} from '../../../../Services/stage.api';
import { useMutation, useQuery } from '@tanstack/react-query';

import CButton from '../../../../Assets/Components/CButton';
import CIcon from '../../../../Assets/Components/CIcon';
import React from 'react';
import StageComponent from '../Component/StageComponent';
import moment from 'moment';
import { toast } from 'react-toastify';
import { toastr } from 'react-redux-toastr';
import { useState } from 'react';
import ErrorHandler from '../../../../App/ErrorHandler';

interface IProps {
  token?: any;
  selectedStatus?: string;
  selectedData?: any;
  channel: any;
  setTabData: (val: any) => void;
}

export default function StageContainer({ channel, setTabData }: IProps) {
  const [filter, setFilter] = useState();
  const [selectedStatus, setSelectedStatus] = useState();
  const [selectedData, setSelectedData] = useState();
  const [modalIsShow, setModalIsShow] = useState(false);

  const {
    data: dataStage,
    refetch: refetchStage,
    isLoading: isLoadingStage,
    isRefetching: isRefetchingStage,
  } = useQuery(
    ['Get Stage Data', channel?.id, filter],
    getNonSelfTrainingStageAPI,
    {
      enabled: channel?.id !== undefined,
      refetchOnWindowFocus: false,
    },
  );

  const mutate = useMutation(mutateNonSelfTrainingStageAPI, {
    onSuccess: () => {
      setModalIsShow(false);
      refetchStage();
      toast.success(
        <span className="capitalFirst">Stage Berhasil Diupdate!</span>,
      );
    },
    onError: (error: any) => {
      ErrorHandler(error);
    },
  });

  const mutationDeleteChannel = useMutation(
    (vals: any) => {
      return deleteNonSelfTrainingStageAPI(vals);
    },
    {
      onError: (error: any) => {
        ErrorHandler(error);
      },
      onSuccess: () => {
        toast.success(
          <span className="capitalFirst">Stage Berhasil Dihapus</span>,
        );
        refetchStage();
      },
    },
  );

  const handleOnClick = () => setModalIsShow(true);

  const processStatusChannel = (id: number, status: any, body: any) => {
    mutate.mutate({ ...body, isActive: status, id });
  };
  const processEnabledStatus = (id: number, status: boolean, row: any) => {
    const oriObj = row.row.original;
    const body = {
      name: oriObj.name,
      description: oriObj.description,
      sequence: oriObj.sequence,
      isActive: status,
      channelId: oriObj.channelId,
    };
    const action = status === true ? 'meng-aktifkan' : 'menon-aktifkan';
    const actionConfirm = status === true ? 'Aktifkan' : 'Non-Aktifkan';
    const toastrConfirmOptions = {
      okText: actionConfirm,
      cancelText: 'Batalkan',
      onOk: () => processStatusChannel(id, status, body),
      id: 'toastRConfirm',
    };
    toastr.confirm(
      `Anda yakin ingin ${action} Stage "${row.row.original.name}"?`,
      toastrConfirmOptions,
    );
  };

  const renderStatus = row => {
    const rowData = row.row.original;
    const processEnabled = isChecked =>
      processEnabledStatus(rowData.id, isChecked, row);
    return (
      <Switch
        onChange={processEnabled}
        checked={rowData.isActive}
        id={rowData.id}
      />
    );
  };

  const renderAction = (row: any) => {
    const rows = row.row.original;
    const handleDelete = () => {
      const toastrConfirmOptions = {
        okText: 'Delete',
        cancelText: 'Batalkan',
        onOk: () => mutationDeleteChannel.mutate(rows.id),
        id: 'toastRConfirm',
      };
      toastr.confirm(`Delete Stage "${rows.name}"`, toastrConfirmOptions);
    };
    const dataButton = [
      {
        id: `btnDeleteChannel`,
        icon: 'DeleteOutlined',
        onClick: handleDelete,
        className: 'btnDelete',
      },
      {
        id: `btnEditChannel`,
        icon: 'EditOutlined',
        onClick: () => {
          setSelectedData(rows);
          setModalIsShow(true);
        },
        className: 'btnEdit',
      },
      {
        id: 'btnNextChannel',
        icon: 'ArrowRightOutlined',
        onClick: () => setTabData(prev => ({ ...prev, stage: rows })),
        className: 'btnNext',
      },
    ];
    return <CButton buttonData={dataButton} />;
  };

  const renderCol = (label, content) => {
    return (
      <>
        <Row className="marginBottom10">
          <Col span={4}>
            <b>{label}</b>
          </Col>
          <Col span={8}>{': ' + content}</Col>
        </Row>
      </>
    );
  };

  const renderRowSubComponent = React.useCallback(({ row }) => {
    const { createdDate, totalClass } = row.original;
    const createDate = moment(createdDate).format('DD-MMM-YYYY');
    return (
      <div>
        {renderCol(
          'Created Date',
          createDate === '01-Jan-0001' ? '-' : createDate,
        )}
        {renderCol(
          'Total Class',
          totalClass === null || totalClass === '' ? '-' : totalClass,
        )}
      </div>
    );
  }, []);

  const columnData = [
    {
      id: 'expanderChannel',
      Cell: ({ row }) => (
        <span {...row.getToggleRowExpandedProps()}>
          {row.isExpanded ? (
            <CIcon type="CaretDownOutlined" />
          ) : (
            <CIcon type="CaretRightOutlined" />
          )}
        </span>
      ),
    },
    {
      Header: 'Stage Name',
      accessor: 'name',
    },
    {
      Header: 'Description',
      accessor: 'description',
    },
    {
      Header: 'Status',
      Cell: (row: any) => renderStatus(row),
    },
    {
      Header: 'Action',
      Cell: (row: any) => renderAction(row),
    },
  ];

  const handleApplyfilter = () => {
    setFilter(selectedStatus);
  };

  return (
    <StageComponent
      columnData={columnData}
      dataStage={dataStage || []}
      isLoading={isLoadingStage || isRefetchingStage}
      modalIsShow={modalIsShow}
      setModalIsShow={setModalIsShow}
      handleAdd={handleOnClick}
      handleRefresh={() => {
        refetchStage();
        setSelectedStatus(undefined);
        setFilter(undefined);
      }}
      refetchStage={refetchStage}
      renderRowSubComponent={renderRowSubComponent}
      channel={channel}
      setSelectedStatus={setSelectedStatus}
      handleApplyfilter={handleApplyfilter}
      selectedData={selectedData}
      selectedStatus={selectedStatus}
      setSelectedData={setSelectedData}
    />
  );
}
